import { action as apiAction } from 'api/Api'

type Payload = {
  cardId: number
  documentSourceId: number
  url: string
}

export default (payload: Payload) => async () => {
  const { cardId, documentSourceId, url } = payload

  try {
    await apiAction('AddDocumentToCard', {
      cardId,
      url,
      documentsSourceId: documentSourceId,
      position: 0
    })
  } catch (error) {
    if (error.code !== 300) { // Duplicate
      throw error
    }
  }
}
